<template>
    <div class="card card-body mt-4">
      <h3>Add new Admin User</h3>
      <form @submit.prevent="submit">
        <div class="form-group">
          <label>Name</label>
          <input v-model="form.name" class="form-control" required />
        </div>
  
        <div class="form-group mt-3">
          <label>Email</label>
          <input
            v-model="form.email"
            class="form-control"
            type="email"
            required
          />
        </div>

        <div class="form-group mt-3">
          <label>Password</label>
          <input
            v-model="form.password"
            class="form-control"
            type="password"
            required
          />
        </div>
  
        <button type="button" class="btn btn-danger mt-3" @click="cancelBtn">
          Cancel
        </button>
  
        <button type="submit" class="btn btn-primary mx-2 mt-3">
          Insert
        </button>
      </form>
    </div>
  </template>
  
  <script>
  import { reactive, computed, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { getAdminUser, createAdminUser } from '@/firebase'
  
  export default {
    setup() {
      const router = useRouter()
      const route = useRoute()
      
  
      const form = reactive({ name: '', email: '' })
        
      const submit = async () => {
        await createAdminUser({ ...form})
        router.push('/adminuser')
        form.username = ''
        form.email = ''
        form.password = ''
      }

      const cancelBtn = () => {
        router.push('/adminuser')
      }
  
      return { form, submit, cancelBtn }
    }
  }
  </script>